<div class="support-bottom-sheet">
  <app-support-data (close)="close()" />
</div>
